import React, { useState } from "react";
import styled from "@emotion/styled";
import Logo from "@components/Header/Logo";
import { ReactComponent as MenuIcon } from "@src/assets/menu.svg";
import Menu from "@components/Header/Menu";
import { useStores } from "@stores";
import { useObserver } from "mobx-react-lite";

interface IProps extends React.HTMLProps<HTMLDivElement> {
  logoColor?: string;
}

const Root = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 8;
  width: 100%;
  padding-top: 15px;
  padding-bottom: 40px;
`;
const CustomLogo = styled.img`
  width: 100px;
  height: auto;
`;
const Header: React.FC<IProps> = ({ logoColor, ...rest }) => {
  const [openedMenu, setOpenedMenu] = useState(false);
  const { cardStore } = useStores();
  const card = useObserver(() => cardStore.card);
  const customLogo = card.settings?.logo;
  return (
    <Root {...rest}>
      {customLogo == null ? (
        <Logo color={logoColor} />
      ) : (
        <CustomLogo src={customLogo} />
      )}
      <MenuIcon
        onClick={() => setOpenedMenu(true)}
        style={{ cursor: "pointer" }}
      />
      {openedMenu && <Menu onClose={() => setOpenedMenu(false)} />}
    </Root>
  );
};
export default Header;
